import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Areas } from "../Areas/Areas";
import { Regiones } from "../Regiones";
import { SubAreas } from "../SubAreas/SubAreas";
import { ACTGestionarTiendas } from "./ACTGestionarTiendas";

const columns = () =>
(
    {
        c_region_id: new EntityColumn<string>({ name: 'c_region_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Región' }),
        c_area_id: new EntityColumn<string>({ name: 'c_area_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Area' }),
        c_subarea_id: new EntityColumn<string>({ name: 'c_subarea_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Subarea' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        rasu_brwStandard: { name: 'rasu_brwStandard', keyMappings: { c_region_id: 4, c_area_id: 5, c_subarea_id: 6 } },
    }
)

const lookups = () =>
(
    {
        'Regiones': {
            name: 'Regiones',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Regiones(client, parentKeys)
        },

        'Areas': {
            name: 'Areas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Areas(client, parentKeys)
        },

        'SubAreas': {
            name: 'SubAreas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new SubAreas(client, parentKeys)
        },

    }
)

const clientActions = () =>
(
    {
        ACTGestionarTiendas: ACTGestionarTiendas
    }
)

export class RegionesAreasSubareasDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();
    clientActions = clientActions();

    constructor() {
        super('RegionesAreasSubareas');
    }
}